import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import ParagraphEmailRenderer from "./email";
import type { ParagraphBlockProps } from "./types";

export default function ParagraphEditorRenderer(props: ParagraphBlockProps) {
  return (
    <EmailComponentWrapper shop={props.shop}>
      <ParagraphEmailRenderer isEditor {...props} />
    </EmailComponentWrapper>
  );
}
